/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/facebook'
export default icon
